<template>
  <div>
    <div class="columns">
      <ul class="price">
        <li class="header" :style="getThemeStyle">{{ plan.title }}</li>
        <li class="grey">{{ getCurrency }} {{ plan.price }} / Year</li>
        <li v-for="(item, ind) in plan.items" :key="ind + Math.random()">
          {{ item }}
        </li>
        <li>{{ plan.itemTwo }}</li>
        <li>{{ plan.itemThree }}</li>
        <li>{{ plan.itemFour }}</li>
        <li class="grey">
          <v-btn rounded large :style="getThemeStyle" @click="goTo(plan)"
            >Get Started</v-btn
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["plan"],
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },

  methods: {
    goTo(plan) {
      this.$router.push({ path: "/onboarding-new-company", query: { plan } });
    },
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

/* Create three columns of equal width */
.columns {
  float: left;
  /* width: 33.3%; */
  padding: 1px;
}

/* Style the list */
.price {
  list-style-type: none;
  border: 1px solid #eee;
  margin: 0;
  padding: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

/* Add shadows on hover */
.price:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
}

/* Pricing header */
.price .header {
  background-color: #111;
  color: white;
  font-size: 25px;
}

/* List items */
.price li {
  border-bottom: 1px solid #eee;
  padding: 10px;
  text-align: center;
}

/* Grey list item */
.price .grey {
  background-color: #eee;
  font-size: 20px;
}

/* The "Sign Up" button */
.button {
  background-color: #04aa6d;
  border: none;
  color: white;
  padding: 10px 25px;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
}

/* Change the width of the three columns to 100%
(to stack horizontally on small screens) */
@media only screen and (max-width: 600px) {
  .columns {
    width: 100%;
  }
}
</style>
